import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';

import { trimTrailingSlash } from '@senet-uiverse/common';

import BASE from '../../app.base';

export const urlInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  if (req.url.includes('/i18n/')) {
    return next(req);
  }

  const origin = trimTrailingSlash(BASE.backendUrl);
  const url = `${origin}${req.url.startsWith('/') ? '' : '/'}${req.url}`;

  return next(req.clone({ url }));
};
